<template>
  <div>
    <div>
      <img src="~@/assets/platform/1.png" />
    </div>
    <div>
      <img src="~@/assets/platform/2.png" />
    </div>
    <div>
      <img src="~@/assets/platform/3.png" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
    div{
        width: 100%;
        img{
            width: 100%;
            height: auto;
        }
    }
</style>